module.exports = __webpack_public_path__ + "img/PT19.58dbec93.svg";